import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { UppBaseModule } from '@unpispas/upp-base';
import { UppWdgtModule } from '@unpispas/upp-wdgt';
import { UppDataModule } from '@unpispas/upp-data';

import { UppPeriodComponent } from '../components/upp-period';

@NgModule({
    declarations: [
      UppPeriodComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        DragDropModule,
        UppBaseModule,
        UppWdgtModule,
        UppDataModule   
    ],
    exports: [
      UppPeriodComponent
    ],
    providers: [],  
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]     
})
export class FeaturePeriodModule {}
